/* eslint-disable indent,import/prefer-default-export */
import fr from 'facet-rest';

const tableHiddenFields = [
  'name',
  'completed',
  'householdId',
  'type',
  'category',
  'dueDate',
  'accurate',
  'relatedId',
  'meetingId',
];

export const RemindersTableOverride = fr.metaOverride()
  .nameOverride(tableHiddenFields, { hidden: true })
  .nameOverride('description', { ordinal: 1, readonly: true })
  .nameOverride('type', { ordinal: 2, hidden: false, readonly: true })
  .done();

export const RemindersCardOverride = fr.metaOverride()
    .nameOverride(tableHiddenFields, { hidden: true })
    .nameOverride('description', { ordinal: 1, readonly: true, prompt: null })
    .nameOverride('type', {
 ordinal: 2, hidden: false, readonly: true, prompt: null,
})
    .done();
